// config
import axios, { handleResp } from '../config/axios';

export const getDashboard = async () => {
    try {
        let respData = await axios({
            url: `/user/dashboard`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getChildNode = async (userId) => {
    try {
        let respData = await axios({
            url: `/user/tree/${userId}`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getTreeInfo = async () => {
    try {
        let respData = await axios({
            url: `/user/tree-info`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getPinList = async (params) => {
    try {
        let respData = await axios({
            url: `/user/pin-list`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getBonusHistory = async (params) => {
    try {
        let respData = await axios({
            url: `/user/bonus-history`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getWithdrawHistory = async (params) => {
    try {
        let respData = await axios({
            url: `/user/withdraw`,
            method: 'get',
            params
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const changePassword = async (data) => {
    try {
        let respData = await axios({
            url: `/user/change-password`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const pinAssign = async (data) => {
    try {
        let respData = await axios({
            url: `/user/pin-assign`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const getBankDetails = async () => {
    try {
        let respData = await axios({
            url: `/user/bank-details`,
            method: 'get'
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};

export const updateBankDetails = async (data) => {
    try {
        let respData = await axios({
            url: `/user/bank-details`,
            method: 'post',
            data
        });

        return handleResp(respData);
    } catch (err) {
        return handleResp(err.response);
    }
};